import { Kosik } from "./Kosik.js";
import { KonfiguraceZbrane as KF } from "./KonfiguraceZbrane.js";
var scrollToElement = require("scroll-to-element");
import strstr from "locutus/php/strings/strstr";
require("@fancyapps/fancybox");

/****************************************************************************************
 *     Slouží pro zobrazení panelů výběru zbraně a uložení hodnot do  KonfiguraceZbrane
 *
 ****************************************************************************************/

var PanelZbrane = {
  Panely: {
    Zbran: {
      name: "Vyber zbraň",
      typ: "ODKAZ_SWITCHER",
      zavislost: false, //--zda je panel zavisly na jine hodnotě
      Cil: "URL",
      title: "Zbraň"
    },
    Urceni: {
      name: "Vyber určení",
      typ: "ODKAZ_SWITCHER",
      zavislost: false,
      Cil: "FILTR",
      title: "Určení"
    },
    Provedeni: {
      name: "Vyber provedení",
      typ: "ODKAZ_SWITCHER",
      zavislost: false,
      Cil: "FILTR",
      title: "Provedení"
    },
    Drzeni: {
      name: "Vyber držení",
      typ: "ODKAZ_SWITCHER",
      zavislost: false,
      Cil: "FILTR",
      title: "Držení"
    },
    Rucka: {
      name: "Vyber ručku",
      typ: "ODKAZ_DO_KATALOGU",
      zavislost: ["Zbran", "Urceni", "Provedeni", "Drzeni"] //Provedeni pouze pro kord a fleret
      //savle
    },

    Cepel: {
      name: "Vyber čepel",
      typ: "ODKAZ_DO_KATALOGU",
      zavislost: ["Zbran", "Urceni"]
    },
    Ciska: {
      name: "Vyber číšku",
      typ: "ODKAZ_DO_KATALOGU",
      zavislost: ["Zbran", "Urceni", "Provedeni"] //Provedeni pouze pro savli
    },
    PodlozkaCisky: {
      name: "Vyber podložku číšky",
      typ: "ODKAZ_DO_KATALOGU",
      zavislost: ["Zbran"]
    },
    Mustek: {
      name: "Vyber můstek",
      typ: "ODKAZ_DO_KATALOGU",
      zavislost: ["Zbran"]
    },
    Matka: {
      name: "Vyber matku",
      typ: "ODKAZ_DO_KATALOGU",
      zavislost: ["Zbran", "Drzeni"]
    },
    Sestaveni: {
      name: "Sestavení",
      typ: "PRIDANI_PRODUKTU",
      //produkt: "16068",
      zavislost: false,
      Url: "/sluzby/kompletace-100kc-sestaveni-zbrane/"
    }
  },

  vypisPanely: function() {
    var $kod = "";

    _.forEach(PanelZbrane.Panely, function($Panel, $idPanelu) {
      $kod += PanelZbrane.vypisJedenPanel($idPanelu, $Panel);
    });

    //           konfigurace_message_final
    $kod += el("div.dvKfMsgfinal");

    return el("div#dvSelPanely", $kod);
  },
  vypisJedenPanel: function($idPanelu, $Panel) {
    var $kod = "";

    let $P = new Panel($idPanelu, $Panel);
    $kod = $P.vratPanel();

    let $viditelnost = ".non";
    if ($idPanelu == "Zbran") $viditelnost = "";

    let $cls = "";
    if ($idPanelu == "Urceni") $cls += ".presun";

    return el(
      "div.dvP" + $viditelnost + $cls + '[data-typ="' + $idPanelu + '"]',
      $kod
    );
  },

  oznacOdkazZaVybrany: function($a) {
    Lc.f("oznacOdkazZaVybrany");
    //---oznaceni odkazu
    $a.parent()
      .children()
      .removeClass("sel");
    $a.addClass("sel");

    /*if ($a.attr("data-id") == "Savle") {
      $('#dvKf .dvP[data-typ="Drzeni"]').addClass("non");
    } else if (!$('#dvKf .dvP[data-typ="Provedeni"]').hasClass("non")) {
      $('#dvKf .dvP[data-typ="Drzeni"]').removeClass("non");
    }
    let vybranaZbran = get(KF, "vybrano.Zbran") || false;
    Lc.log("vybrano", vybranaZbran);

    //--zobrazeni dalsiho panelu
    let $dvP = $a.closest(".dvP");

    if ($dvP.attr("data-typ") == "Provedeni" && vybranaZbran == "Savle") {
      $dvP.nextAll().removeClass("non");
      $('#dvKf .dvP[data-typ="Drzeni"]').addClass("non");
    } else {
      $dvP.next().removeClass("non");

      //---presun na dalsi prvek
      let $idDalsiho = $dvP.next().data("typ");
      scrollToElement('.dvP[data-typ="' + $idDalsiho + '"]');

      //---zob razeni vsech dalsich panelu
      if ($dvP.data("typ") == "Drzeni") {
        $dvP.nextAll().removeClass("non");
      }
    }
    */

    //--zobrazeni dalsiho panelu
    let $dvP = $a.closest(".dvP");

    $dvP.next().removeClass("non");

    //---presun na dalsi prvek
    let $idDalsiho = $dvP.next().data("typ");
    scrollToElement('.dvP[data-typ="' + $idDalsiho + '"]');

    //---zob razeni vsech dalsich panelu
    if ($dvP.data("typ") == "Drzeni") {
      $dvP.nextAll().removeClass("non");
    }
  },

  nastavUdalosti: function($div) {
    $div.find(".chs a").click(function(event) {
      let $a = $(this);

      //---oznaci vybranyOdkaz a rozbalí další položky
      PanelZbrane.oznacOdkazZaVybrany($a);

      //---ulozeni vyberu
      let $dvP = $a.closest(".dvP");
      KF.ulozVyber($dvP.data("typ"), $a.data("id"));
      /*
      let vybranaZbran = get(KF, "vybrano.Zbran") || false;

      if (KF.vybrano["Drzeni"]) {
        $div.find(".dvOdk").trigger("ladzo:nastavHodnotyProOdkazyDoKatalogu");
      } else if (
        vybranaZbran &&
        vybranaZbran == "Savle" &&
        KF.vybrano["Provedeni"]
      ) {
        $div.find(".dvOdk").trigger("ladzo:nastavHodnotyProOdkazyDoKatalogu");
      }
      */
      if (KF.vybrano["Drzeni"]) {
        $div.find(".dvOdk").trigger("ladzo:nastavHodnotyProOdkazyDoKatalogu");
      }

      event.preventDefault
        ? event.preventDefault()
        : (event.returnValue = false);
    });

    $div.find(".dvOdk").on("ladzo:panelNactiProdukty", function() {
      Lc.e("ladzo:panelNactiProdukty");

      var $c = $(this).find(".dvPr");
      let $typPanelu = $c.closest(".dvP").data("typ");

      if (!Kosik.polozky) {
        $c.html("");
        $c.removeClass("full");
        return false;
      }

      let $arrProdId = [];
      _.forEach(Kosik.polozky, function($Val, $priceId) {
        if ($Val.druhZbozi != $typPanelu) return;
        else if ($c.find('.item[data-id="' + $priceId + '"]').length) {
          $arrProdId.push($priceId);

          return;
        } else {
          $arrProdId.push($priceId);
        }

        //---pridani noveho produktu
        let $product = Panel.vratProdukt($priceId, $Val);
        $c.append($product);
      });

      if ($arrProdId.length) {
        $c.addClass("full");
      } else $c.removeClass("full");

      //---odstraneni produktu smazanych
      $c.find(".item").each(function() {
        let $id = $(this).data("id") + "";
        if ($arrProdId.indexOf($id) == -1) $(this).remove();
      });
    });

    $(document).on("ladzo:aktualizacePaneluZbrane", function() {
      Lc.e("ladzo:aktualizacePaneluZbrane");
      Lc.log("div", $div);

      $div.find(".dvOdk").trigger("ladzo:panelNactiProdukty");

      //WidgetKosik.Panel.aktualizuj();
      //if(KF.odkazyJakoIframe)WidgetKosik.Panel.odkazyDoPopupOkna();

      //---doplneni hlasky do posledniho boxu
      $div.find(".dvKfMsgfinal").trigger("ladzo:panelAktualizujFinalniHlasku");
    });

    $div
      .find(".dvOdk")
      .on("ladzo:nastavHodnotyProOdkazyDoKatalogu", function() {
        Lc.e("ladzo:nastavHodnotyProOdkazyDoKatalogu");
        // console.log('----------zavolan event2-----');

        let $a = $(this).find("a");
        let $typPanelu = $a.closest(".dvP").data("typ");

        let $Obj = PanelZbrane.Panely[$typPanelu];

        let $KfOdk = KF[$typPanelu] || false;

        var $url = "";
        var $urlParams = new URLSearchParams();

        if ($Obj.zavislost) {
          $Obj.zavislost.forEach(function(entry) {
            let $B = PanelZbrane.Panely[entry];
            let $C = KF[entry];
            let $D = KF[entry][KF.vybrano[entry]];
            if (
              $typPanelu == "Ciska" &&
              KF.vybrano["Zbran"] != "Savle" &&
              entry == "Provedeni"
            ) {
              return; //continue
            } else if (
              $typPanelu == "Rucka" &&
              KF.vybrano["Zbran"] == "Savle" &&
              entry == "Provedeni"
            ) {
              return; //continue
            }

            if ($B.Cil == "URL") {
              $url += $D.url;
            } else {
              $urlParams.set($C["_filterID"], $D.param);
            }
          });
        }
        if ($typPanelu == "Sestaveni") {
          $url = PanelZbrane.Panely["Sestaveni"].Url;
        }

        if (!$url) $url = KF.defaultUrl;

        if ($KfOdk && $KfOdk["_filterID"])
          $urlParams.set($KfOdk["_filterID"], $KfOdk["_param"]);

        $urlParams.set("vypisKf", true);

        $url = $url + "?" + $urlParams.toString();
        if (KF.odkazyJakoIframe) {
          $url = $url + "#iframe";
        }

        $a.attr("href", $url);

        // Lc.log("href", $url);

        //---ulozeni adres pro pozdejsi potreby
        KF.ulozUrlAdresu($typPanelu, $url);
      });

    $div
      .find(".dvKfMsgfinal")
      .on("ladzo:panelAktualizujFinalniHlasku", function() {
        Lc.e("ladzo:panelAktualizujFinalniHlasku");

        var $div = $(this);

        try {
          if (!KF.vybraneVolby()) throw new Error("Nebyly vybrané volby");

          if (!KF.vybraneVolbyVKOsiku())
            throw new Error("V košíku nejsou všechny položky");

          let $msg = get(KF, "Config.konfigurace_message_final") || false;
          if (!$msg) throw new Error("Nenačtena hláška");

          //let $hlaska=$msg + Math.random();
          let $hlaska = $msg;
          $div.addClass("full").html($hlaska);
        } catch (err) {
          $div.removeClass("full").html("");
          Lc.ctch("ladzo:panelAktualizujFinalniHlasku");
          Lc.log("catch", err.message);
        }
      });

    //doplněni helpu
    $div.find(".dvP").on("ladzo:panelAktualizujNapovedy", function() {
      //Lc.e("ladzo:panelAktualizujNapovedy");
      var $div = $(this);
      var $idDivu = $div.attr("data-typ");
      try {
        let $msg = get(KF, "Config.help." + $idDivu) || false;
        if (!$msg) throw new Error("Nenačtena hláška pro KF typ");

        if ($div.find(">h2 a.aHelp").lenght) {
          $div.find(">h2 a.aHelp").remove();
        }

        let $a = `
          <a href="" rel="modal:open"  data-original-title="${fce.escapeHtml(
            $msg
          )}" class="aPopoverVice"><em>?</em></a>`; //rel="modal:open"
        $div.find(">h2").append($a);

        $div
          .find(">h2 .aPopoverVice")
          .popover({
            animation: false,
            placement: "top",
            // trigger: 'click',
            html: true,
            delay: { show: 750, hide: 100 },
            container: $(this).attr("id"),
            content: function() {
              //$return = '<div class="hover-hovercard"></div>';
            }
          })
          .on("mouseenter", function() {
            var _this = this;
            $(this).popover("show");
            $(this)
              .siblings(".popover")
              .on("mouseleave", function() {
                $(_this).popover("hide");
              });
          })
          .on("mouseleave", function() {
            var _this = this;
            setTimeout(function() {
              if (!$(".popover:hover").length) {
                $(_this).popover("hide");
              }
            }, 100);
          });
      } catch (err) {
        // Lc.log("msg", $msg);
      }
    });
  },

  nastavVychoziHodnoty: function($div, $vybrano) {
    _.forEach($vybrano, function($val, $key) {
      if ($val === false) return;

      let $a = $div.find(
        '.dvP[data-typ="' + $key + '"] a[data-id="' + $val + '"]'
      );
      PanelZbrane.oznacOdkazZaVybrany($a);
    });
    if ($vybrano.Drzeni) {
      $div.find(".dvOdk").trigger("ladzo:nastavHodnotyProOdkazyDoKatalogu");
      //$div.find('.dvOdk').trigger("ladzo:panelNactiProdukty");
    }
  },

  odkazyDoPopupOkna: function($div) {
    Lc.f("odkazyDoPopupOkna");
    $div.find(".dvOdk a").each(function() {
      //var $href = $(this).attr("href");
      //$(this).attr("href", $href + "#iframe");
      //$(this).attr('href',$href + '#iframe').attr('title','Rychlý náhled').addClass('aFrame').text('Rychlý náhled');
      //$(this).attr("href", $href + "#iframe");
      $(this).attr("data-fancybox", "");
      $(this).attr("data-type", "iframe");

      $(this).fancybox({
        autoStart: false,
        iframe: {
          preload: true,
          css: {
            height: window.innerHeight - 50 + "px"
          }
        },
        afterClose: function() {
          Lc.e("after close 2");
          Kosik.aktualizujZavisle();
        }
      });
      /*
      $(this).magnificPopup({
        //preloader: true,
        type: "iframe",
        iframe: {
          markup:
            '<div class="mfp-iframe-scaler your-special-css-class">' +
            '<div class="mfp-close"></div>' +
            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen>            </iframe>' +
            "</div>"
        },

        //preloader: true,

        callbacks: {
          beforeOpen: function() {
            Lc.f("iframe:beforeOpen");
            var $href = $(this).attr("href");
            $(this).attr("href", $href + "#iframe");
          },

          close: function() {
            Lc.e("Magnfic close");
            Kosik.aktualizujZavisle();
            //$(document).trigger("ladzo:aktualizaceWidgetuKosiku");
            // Will fire when popup is closed
          }
          // e.t.c.
        }
      });
      */
    });
  },

  vratUrlProOdkazDoKatalogu: function() {},

  _init: function() {}
}; //var PanelZbrane

class Panel {
  constructor($idPanelu, $Panel) {
    this.idPanelu = $idPanelu;
    this.Panel = $Panel;
  }

  vratPanel() {
    let $kod = "";

    $kod += el("h2", this.Panel.name);
    if (this.Panel.typ == "ODKAZ_SWITCHER") {
      $kod += this.panelSwitcher();
    } else if (this.Panel.typ == "PRIDANI_PRODUKTU") {
      $kod += this.panelPridaniProduktu();
    } else {
      $kod += this.panelOdkazDoKatalogu();
    }

    return $kod;
  }
  panelSwitcher() {
    let $arr = [];

    let $Odk = KF[this.idPanelu];

    _.forEach($Odk, function($Val, $id) {
      if (_.startsWith($id, "_")) return;
      let $a = el('a[data-id="' + $id + '"]', $Val.name);

      $arr.push($a);
    });
    return el("div.dvFlx.chs", $arr);
  }
  panelOdkazDoKatalogu() {
    let $Odk = KF[this.idPanelu];

    let $a = el('a.afr[target="_blank"]', $Odk.name);

    let $dvProdukty = el("div.dvPr");

    return el("div.dvOdk", [$a, $dvProdukty]);
  }

  panelPridaniProduktu() {
    let $Odk = KF[this.idPanelu];
    let $a = el('a.afr[target="_blank"]', $Odk.name);

    let $dvProdukty = el("div.dvPr");

    return el("div.dvOdk", [$a, $dvProdukty]);
  }

  static vratPopisVarianty($objForm) {
    let $b;
    if (!($b = $objForm.popisVarianty)) return false;

    //popisVarianty: "Velikost: XL, Provedení: levé&nbsp;- Skladem&nbsp;&gt; 5 ks&nbsp; (155 Kč)"
    let $pom = strstr($b, "&nbsp;-", true);

    return "(" + $pom + ")";
  }

  static vratProdukt($priceId, $P) {
    Lc.f("vratProdukt");
    Lc.log("product", $P);

    let $div = el("h3", el('a[href="' + $P.urlProduktu + '"]', $P.name));

    //---popisek varianty
    let $popisVarinty = Panel.vratPopisVarianty($P);

    $div += el("div.dvVar", $popisVarinty ? $popisVarinty : "");

    let $img = el('img[src="' + $P.obr + '"]');

    $div += el("div.obr", el('a[href="' + $P.urlProduktu + '"]', $img));

    return el('div.item[data-id="' + $priceId + '"]', $div);
  }
}

PanelZbrane._init();

export { PanelZbrane };
